// eslint-disable-next-line import/prefer-default-export
export const totallyDarkeChartsTheme = {
  color: [
    '#dd6b66',
    '#759aa0',
    '#e69d87',
    '#8dc1a9',
    '#ea7e53',
    '#eedd78',
    '#73a373',
    '#73b9bc',
    '#7289ab',
    '#91ca8c',
    '#f49f42',
  ],
  backgroundColor: 'rgba(0,0,0,1)',
  textStyle: {},
  title: {
    textStyle: {
      color: '#ffffff',
    },
    subtextStyle: {
      color: '#ffffff',
    },
  },
  line: {
    itemStyle: {
      borderWidth: 1,
    },
    lineStyle: {
      width: 2,
    },
    symbolSize: 4,
    symbol: 'circle',
    smooth: false,
  },
  radar: {
    itemStyle: {
      borderWidth: 1,
    },
    lineStyle: {
      width: 2,
    },
    symbolSize: 4,
    symbol: 'circle',
    smooth: false,
  },
  bar: {
    itemStyle: {
      barBorderWidth: 0,
      barBorderColor: '#eeeeee',
    },
  },
  pie: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  scatter: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  boxplot: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  parallel: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  sankey: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  funnel: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  gauge: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
  },
  candlestick: {
    itemStyle: {
      color: '#fd1050',
      color0: '#0cf49b',
      borderColor: '#fd1050',
      borderColor0: '#0cf49b',
      borderWidth: 1,
    },
  },
  graph: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#eeeeee',
    },
    lineStyle: {
      width: 1,
      color: '#aaa',
    },
    symbolSize: 4,
    symbol: 'circle',
    smooth: false,
    color: [
      '#dd6b66',
      '#759aa0',
      '#e69d87',
      '#8dc1a9',
      '#ea7e53',
      '#eedd78',
      '#73a373',
      '#73b9bc',
      '#7289ab',
      '#91ca8c',
      '#f49f42',
    ],
    label: {
      color: '#ffffff',
    },
  },
  map: {
    itemStyle: {
      normal: {
        areaColor: '#eee',
        borderColor: '#444',
        borderWidth: 0.5,
      },
      emphasis: {
        areaColor: 'rgba(255,215,0,0.8)',
        borderColor: '#444',
        borderWidth: 1,
      },
    },
    label: {
      normal: {
        textStyle: {
          color: '#000',
        },
      },
      emphasis: {
        textStyle: {
          color: 'rgb(100,0,0)',
        },
      },
    },
  },
  geo: {
    itemStyle: {
      normal: {
        areaColor: '#eee',
        borderColor: '#444',
        borderWidth: 0.5,
      },
      emphasis: {
        areaColor: 'rgba(255,215,0,0.8)',
        borderColor: '#444',
        borderWidth: 1,
      },
    },
    label: {
      normal: {
        textStyle: {
          color: '#000',
        },
      },
      emphasis: {
        textStyle: {
          color: 'rgb(100,0,0)',
        },
      },
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#ffffff',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: [
          '#aaaaaa',
        ],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [
          '#eeeeee',
        ],
      },
    },
  },
  valueAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#ffffff',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: [
          '#aaaaaa',
        ],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [
          '#eeeeee',
        ],
      },
    },
  },
  logAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#ffffff',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: [
          '#aaaaaa',
        ],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [
          '#eeeeee',
        ],
      },
    },
  },
  timeAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: '#eeeeee',
      },
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: '#ffffff',
      },
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: [
          '#aaaaaa',
        ],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [
          '#eeeeee',
        ],
      },
    },
  },
  toolbox: {
    iconStyle: {
      normal: {
        borderColor: '#ffffff',
      },
      emphasis: {
        borderColor: '#666',
      },
    },
  },
  legend: {
    textStyle: {
      color: '#ffffff',
    },
  },
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: '#ffffff',
        width: '1',
      },
      crossStyle: {
        color: '#ffffff',
        width: '1',
      },
    },
    backgroundColor: '#333333',
    textStyle: {
      color: '#ffffff',
    },
  },
  timeline: {
    lineStyle: {
      color: '#eeeeee',
      width: 1,
    },
    itemStyle: {
      normal: {
        color: '#dd6b66',
        borderWidth: 1,
      },
      emphasis: {
        color: '#a9334c',
      },
    },
    controlStyle: {
      normal: {
        color: '#eeeeee',
        borderColor: '#eeeeee',
        borderWidth: 0.5,
      },
      emphasis: {
        color: '#eeeeee',
        borderColor: '#eeeeee',
        borderWidth: 0.5,
      },
    },
    checkpointStyle: {
      color: '#e43c59',
      borderColor: '#c23531',
    },
    label: {
      normal: {
        textStyle: {
          color: '#eeeeee',
        },
      },
      emphasis: {
        textStyle: {
          color: '#eeeeee',
        },
      },
    },
  },
  visualMap: {
    color: [
      '#bf444c',
      '#d88273',
      '#f6efa6',
    ],
    textStyle: {
      color: '#ffffff',
    },
  },
  dataZoom: {
    backgroundColor: 'rgba(47,69,84,0)',
    dataBackgroundColor: 'rgba(255,255,255,0.3)',
    fillerColor: 'rgba(167,183,204,0.4)',
    handleColor: '#a7b7cc',
    handleSize: '100%',
    textStyle: {
      color: '#eeeeee',
    },
  },
  markPoint: {
    label: {
      color: '#ffffff',
    },
    emphasis: {
      label: {
        color: '#ffffff',
      },
    },
  },
};
